/**
 * Canonical aliases that hide data-vendor names in user-facing strings.
 * Keep in sync with backend/app/core/signal_providers.py.
 */

export const SIGNAL_PROVIDER = {
  liveIntent: { id: 1, slug: 'live_intent', label: 'Signal Provider 01' },
  ipost: { id: 2, slug: 'ipost', label: 'Signal Provider 02' },
  traverse: { id: 3, slug: 'traverse', label: 'Signal Provider 03' },
  towerdata: { id: 4, slug: 'towerdata', label: 'Signal Provider 04' },
  audienceAcuity: { id: 5, slug: 'audience_acuity', label: 'Signal Provider 05' },
};

export const SIGNAL_PROVIDER_CHART_ORDER = [
  SIGNAL_PROVIDER.liveIntent.label,
  SIGNAL_PROVIDER.ipost.label,
  SIGNAL_PROVIDER.traverse.label,
  'Other',
];

const REPLACEMENTS = [
  [/audience[\s_-]*acuity/gi, SIGNAL_PROVIDER.audienceAcuity.label],
  [/live[\s_-]*intent/gi, SIGNAL_PROVIDER.liveIntent.label],
  [/tower[\s_-]*data/gi, SIGNAL_PROVIDER.towerdata.label],
  [/(^|[^a-z0-9])i[\s_-]*post(?![a-z0-9])/gi, `$1${SIGNAL_PROVIDER.ipost.label}`],
  [/(^|[^a-z0-9])traverse(?![a-z0-9])/gi, `$1${SIGNAL_PROVIDER.traverse.label}`],
  [/(^|[^a-z0-9])aa_(?:data|financial)(?![a-z0-9])/gi, `$1${SIGNAL_PROVIDER.audienceAcuity.label}`],
  [/(^|[^a-z0-9])aa(?=_)/gi, `$1${SIGNAL_PROVIDER.audienceAcuity.label}`],
  [/(^|[^a-z0-9])aa(?![a-z0-9])/gi, `$1${SIGNAL_PROVIDER.audienceAcuity.label}`],
];

const DETECT_RE = new RegExp(REPLACEMENTS.map(([re]) => `(?:${re.source})`).join('|'), 'i');

function tidyProviderLabels(value) {
  return String(value || '')
    .replace(/(Signal Provider \d{2})[_]+/g, '$1 ')
    .replace(/[_]+(Signal Provider \d{2})/g, ' $1')
    .replace(/ {2,}/g, ' ')
    .trim();
}

export function sanitizeVendorText(value) {
  const s = value == null ? '' : String(value);
  if (!s || !DETECT_RE.test(s)) return s;
  let out = s;
  for (const [pattern, label] of REPLACEMENTS) {
    pattern.lastIndex = 0;
    out = out.replace(pattern, label);
  }
  return tidyProviderLabels(out);
}

export function containsVendorToken(value) {
  const s = value == null ? '' : String(value);
  if (!s) return false;
  DETECT_RE.lastIndex = 0;
  return DETECT_RE.test(s);
}

export function vendorTokensIn(values) {
  return (values || []).some((v) => containsVendorToken(v));
}

/** User-facing dictionary fields that Segment Builder will show. */
export function dictionaryRowHasVendorTokens(row) {
  if (!row) return false;
  const folders = Array.isArray(row.folder_list) ? row.folder_list.join('/') : row.folder_list;
  const tags = Array.isArray(row.tags) ? row.tags.join(',') : row.tags;
  return vendorTokensIn([row.display_name, row.description, folders, tags]);
}
